import { render, staticRenderFns } from "./Emptybody.vue?vue&type=template&id=0dfe778e&scoped=true"
import script from "./Emptybody.vue?vue&type=script&lang=js"
export * from "./Emptybody.vue?vue&type=script&lang=js"
import style0 from "./Emptybody.vue?vue&type=style&index=0&id=0dfe778e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe778e",
  null
  
)

export default component.exports